<template>
  <a class="skip-main button" href="#main">Skip naar content</a>
  <div class="header">
    <div class="container">
      <div class="nav">
        <div class="nav__logo">
          <router-link to="/" title="Erasmus+ | Subsidiewijzer">
            <img alt="Erasmus+" src="./assets/logo.svg" />
            <p class="nav__logo--sub">Subsidiewijzer</p>
          </router-link>
        </div>
        <div class="nav__right">
          <div class="nav__right--mainsite">
            <a
              href="https://www.erasmusplus.nl/privacy-cookies"
              title="Open privacy verklaring in nieuwe tab"
              target="_blank"
              rel="noopener"
              >Privacy verklaring</a
            >
            <a
              href="https://www.erasmusplus.nl/"
              title="erasmusplus.nl"
              target="_blank"
              rel="noopener"
              >Naar erasmusplus.nl</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view v-slot="{ Component }">
    <transition name="fade">
      <component :is="Component" />
    </transition>
  </router-view>
  <div class="footer">
    <a
      href="https://www.erasmusplus.nl/privacy-cookies"
      title="Open privacy verklaring in nieuwe tab"
      target="_blank"
      rel="noopener"
      >Privacy verklaring</a
    >
    <a
      href="https://www.erasmusplus.nl/"
      title="erasmusplus.nl"
      target="_blank"
      rel="noopener"
      >Naar erasmusplus.nl</a
    >
  </div>
</template>

<style lang="scss">
@use "sass:math";
@import "style/vars";
@import "style/reset.scss";
@import "style/fonts.scss";
@import "style/global.scss";

.skip-main {
  left: -999px;
  position: fixed;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -999;
  border-radius: 24.5px;
  overflow: auto;
  margin: 10px 35%;
  padding: 5px;
  text-align: center;
  font-size: 1.2em;

  &:focus {
    width: 30%;
    height: auto;
    left: auto;
    top: auto;
    z-index: 999;
  }
}

.header {
  position: relative;
  z-index: 10;
}

.nav {
  z-index: 10;
  width: 100%;
  text-align: center;
  //padding: $base-padding 0;
  padding: 1rem 0;
  @media (min-width: $breakpoint-xl) {
    display: flex;
    flex-wrap: wrap;
    padding: ($base-padding * 1.35) 0;
  }
  @media (min-width: $breakpoint-xxl) {
    padding: ($base-padding * 1.35) math.div($base-padding, 1.28);
  }
  &__logo {
    z-index: 11;
    a {
      text-decoration: none;
      @media (min-width: $breakpoint-xl) {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      }
    }
    img {
      width: 12.3125rem;
      height: 3.5625rem;
    }
    &--sub {
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      color: $white;
      font-size: 1.375rem;
      margin-top: math.div($base-padding, 2);
      margin-bottom: 0;
      @media (min-width: $breakpoint-xl) {
        margin-left: ($base-padding * 1.5);
        margin-top: math.div($base-padding, 1.3);
      }
    }
    @media (min-width: $breakpoint-xl) {
      display: flex;
      width: 50%;
    }
  }
  &__right {
    @media (min-width: $breakpoint-xl) {
      position: absolute;
      top: 0;
      right: 50%;
      left: 50%;
      transform: translateX(-50%);
      width: 100vw;
      height: 100%;
    }
    &--mainsite {
      width: 100%;
      text-align: center;
      padding: math.div($base-padding, 2) 0 0;
      display: none;
      @media (min-width: $breakpoint-xl) {
        display: flex;
        gap: 1.875rem;
      }
      a {
        @include hover-line-link;
        @media (min-width: $breakpoint-xl) {
          top: math.div(-$base-padding, 3);
        }
      }
      @media (min-width: $breakpoint-xl) {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 100%;
        width: math.div(100%, 1.5);
        text-align: right;
        padding: 0 $base-padding;
      }
      @media (min-width: $breakpoint-xxl) {
        padding-right: ($base-padding + math.div($base-padding, 1.28));
      }
    }
  }
}

.footer {
  padding: 0 1.75rem 1.75rem;
  text-align: center;
  display: flex;
  gap: 1.25rem;
  align-items: center;
  justify-content: center;
  @media (min-width: $breakpoint-xl) {
    display: none;
  }
  a {
    @include hover-line-link;
    @media (min-width: $breakpoint-xl) {
      top: math.div(-$base-padding, 3);
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
